import InitialLoader from "components/InitilalLoader";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import "../../Subscription/Subscription.scss";
import CommonCewSeriesInput from "./CommonCrewSeriesInput";
import { randomKey } from "../../../utils/utils";
import { useCategoryOptions } from "./hooks/useCategoryOptions";
import { useCategoryAllSeries } from "./hooks/useCategoryAllSeries";
import { useAddUpdateSeries } from "./hooks/useAddUpdateSeries";
import { useDeleteSeriesType } from "./hooks/useDeleteSeriesType";
import DeleteConfirmModal from "components/common/DeleteConfirmModal";

function CrewPricing() {
  const [selectCatagory, setSelectCatagory] = useState("");
  const [selectCatagoryType, setSelectCatagpryType] = useState("");
  const [selectSubType, setSelectSubType] = useState("");
  const [selectRoofPitch, setSelectRoofPitch] = useState("");
  const [selectStyle, setSelectStyle] = useState("");
  const [add, setAdd] = useState(false);
  const [addNewSeries, setAddNewSeries] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const { data: pricing, isLoading } = useCategoryOptions();

  const catEntry = pricing.find((p) => p.category === selectCatagory);
  const typesList = catEntry ? catEntry.categoryType.map((t) => t.typeName) : [];
  const ctEntry = catEntry?.categoryType.find((t) => t.typeName === (selectCatagoryType || selectCatagory))
    ?? (catEntry?.categoryType.length === 1 ? catEntry.categoryType[0] : undefined);
  const subTypeList = ctEntry?.subType || [];
  const subName = ctEntry?.subTypeName || "";
  const roofPitchList = ctEntry?.roofPitch || [];
  const styleList = ctEntry?.style || [];

  const seriesParams = (() => {
    if (!selectCatagory) return null;
    const base = { category: selectCatagory, categoryType: selectCatagoryType || selectCatagory };
    if (typesList.length > 1 && !selectCatagoryType) return null;
    if (subTypeList.length > 0 && !selectSubType) return null;
    if (selectSubType) {
      if (styleList.length > 0 && !selectStyle) return null;
      if (roofPitchList.length > 0 && !selectRoofPitch) return null;
      return { ...base, subType: selectSubType, ...(selectStyle && { style: selectStyle }), ...(selectRoofPitch && { roofPitch: selectRoofPitch }) };
    }
    return base;
  })();

  const { data: loborSeriesData = [], isLoading: isLoadingSeries } = useCategoryAllSeries(seriesParams);
  const { mutate: saveOrUpdate } = useAddUpdateSeries();
  const { mutate: remove, isPending: isDeleting } = useDeleteSeriesType();

  useEffect(() => { setSelectCatagpryType(""); setSelectSubType(""); setSelectRoofPitch(""); setSelectStyle(""); setAdd(false); }, [selectCatagory]);
  useEffect(() => { setSelectSubType(""); setSelectRoofPitch(""); setSelectStyle(""); }, [selectCatagoryType]);
  useEffect(() => { setSelectRoofPitch(""); setSelectStyle(""); }, [selectSubType]);

  const handleChange = (e, callback) => callback(e.target.value);
  const showOptions = (list) => list.map((d) => <option key={d} value={d}>{d}</option>);
  const showAddNew = !!seriesParams;
  const saveData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const editData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const deleteData = (id) => { setDeleteId(id); setIsDelete(true); };
  const confirmDelete = () => { remove(deleteId, { onSuccess: () => { setIsDelete(false); setDeleteId(null); }, onError: () => { setIsDelete(false); setDeleteId(null); } }); };

  if (isLoading) return <InitialLoader />;

  return (
    <>
      <DeleteConfirmModal
        isOpen={isDelete}
        toggle={() => !isDeleting && setIsDelete(false)}
        onConfirm={confirmDelete}
        isLoading={isDeleting}
      />

      <Row style={{ marginBottom: "2%" }}>
        <Col md="3">
          <Form.Group>
            <Form.Label>Category</Form.Label>
            <Form.Control as="select" value={selectCatagory} onChange={(e) => handleChange(e, setSelectCatagory)}>
              <option value="">Choose...</option>
              {showOptions(pricing.map((p) => p.category))}
            </Form.Control>
          </Form.Group>
        </Col>

        {typesList.length > 1 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>{selectCatagory} Type</Form.Label>
              <Form.Control as="select" value={selectCatagoryType} onChange={(e) => handleChange(e, setSelectCatagpryType)}>
                <option value="">Choose...</option>
                {showOptions(typesList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {subTypeList.length > 0 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>{subName}</Form.Label>
              <Form.Control as="select" value={selectSubType} onChange={(e) => handleChange(e, setSelectSubType)}>
                <option value="">Choose...</option>
                {showOptions(subTypeList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {selectSubType && styleList.length > 0 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>Style</Form.Label>
              <Form.Control as="select" value={selectStyle} onChange={(e) => handleChange(e, setSelectStyle)}>
                <option value="">Choose...</option>
                {showOptions(styleList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {selectSubType && roofPitchList.length > 0 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>Roof Pitch</Form.Label>
              <Form.Control as="select" value={selectRoofPitch} onChange={(e) => handleChange(e, setSelectRoofPitch)}>
                <option value="">Choose...</option>
                {showOptions(roofPitchList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}
      </Row>

      {isLoadingSeries ? <InitialLoader /> : (
        <>
          {showAddNew && !add && (
            <Row style={{ marginBottom: "4%", float: "right" }}>
              <Col md="12">
                <button className="btn btn-primary" onClick={() => { setAdd(true); setAddNewSeries(true); }}>Add New</button>
              </Col>
            </Row>
          )}

          {loborSeriesData?.length > 0 && (
            <Row style={{ marginTop: "10%" }}>
              {loborSeriesData[0].accessory && loborSeriesData[0].accessory !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Accessory</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].roofPitch && loborSeriesData[0].roofPitch !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Roof Pitch</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].workType && loborSeriesData[0].workType !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Work Type</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].subType && loborSeriesData[0].subType !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>{subName}</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].style && loborSeriesData[0].style !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Style</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].color && loborSeriesData[0].color !== "N/A" && <Col md="1"><Form.Group style={{ textAlign: "center" }}><Form.Label>Color</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].size && loborSeriesData[0].size !== "N/A" && <Col md="1"><Form.Group style={{ textAlign: "center" }}><Form.Label>Size</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].uom && loborSeriesData[0].uom !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>UOM</Form.Label></Form.Group></Col>}
              {loborSeriesData[0].uomPrice && loborSeriesData[0].uomPrice !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Price Per UOM</Form.Label></Form.Group></Col>}
            </Row>
          )}

          {add && loborSeriesData?.length > 0 && (
            <CommonCewSeriesInput
              saveData={saveData} editData={true}
              isAcessory={loborSeriesData[0].accessory} isColors={loborSeriesData[0].color}
              isRoofPitchs={loborSeriesData[0].roofPitch} isSizes={loborSeriesData[0].size}
              isStyles={loborSeriesData[0].style} isSubTypes={loborSeriesData[0].subType}
              isUOM={loborSeriesData[0].uom} UOM={loborSeriesData[0].uom}
              isWorkTypes={loborSeriesData[0].workType} isPricepweruom={loborSeriesData[0].uomPrice}
              setAddNewSeries={setAddNewSeries} addNewSeries={addNewSeries}
              category={selectCatagory} style={selectStyle}
              categoryType={selectCatagory === "Gutters/Leaders" ? selectCatagoryType : selectCatagory}
              subType={selectSubType} roofPitch={selectCatagory === "Flat Roofing" ? "Flat" : selectRoofPitch}
              add={add} deleteData={deleteData} setAdd={setAdd}
            />
          )}

          {loborSeriesData?.length > 0
            ? loborSeriesData.map((data) => (
              <CommonCewSeriesInput
                key={data._id || randomKey}
                setAddNewSeries={setAddNewSeries} saveData={editData} deleteData={deleteData}
                acessory={data.accessory} colors={data.color} roofPitch={data.roofPitch}
                sizes={data.size} style={data.style} subType={data.subType}
                UOM={data.uom} workTypes={data.workType} _id={data._id}
                pricepweruom={data.uomPrice} addNewSeries={addNewSeries}
                category={data.category} categoryType={data.categoryType}
                setAdd={setAdd} priceData={data}
              />
            ))
            : showAddNew && <h6 style={{ textAlign: "center", marginTop: "10%" }}>No Data Found</h6>}
        </>
      )}
    </>
  );
}

export default CrewPricing;
